import { BaseEndpoint } from "../base.endpoint"
import { Headers } from "../../types/request"
import { InnovationEmailAttributes } from "../../types/attributes"

export class InnovationLabForm extends BaseEndpoint {
  public async sendConfirmationEmail(
    body: InnovationEmailAttributes,
    headers?: Headers
  ): Promise<{ status: boolean }> {
    const { data } = await this.http.post(
      this.routes.innovationLabSendConfirmationEmail(),
      { ...body },
      {
        headers,
      }
    )
    return data
  }
}
